/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconSun = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 26 26"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 26px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeWidth={weight === "normal" ? 1.5 : 1}
        className="icon-sun-group"
        transform="translate(1 1)"
      >
        <circle cx={12} cy={12} r={7} />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 0v2m0 20v2m8.236-20.642l-1.124 1.179M4.888 19.463l-1.124 1.18M24 12h-2M2 12H0m20.236 8.643l-1.124-1.179M4.888 4.536L3.764 3.357"
        />
      </g>
    </svg>
  ),
);
